import { ConfirmModalService } from './../shared/confirm-modal/confirm-modal.service';
import { Subscription } from 'rxjs';
import { NotificationService } from './../../services/notification.service';
import { MenuService } from './../../services/menu.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { RouteDataService } from './../../services/route-data.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { Component, HostBinding, Inject, OnInit, OnDestroy, ViewChild, Renderer2 } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { APP_CONFIG } from '../../app.config';
import { IAppConfig } from '../../app.config.shared';
import { LoginService } from '../../services/login.service';
declare var SnapEngage;
declare var $;
@Component({
  selector: 'app-parent-menu',
  templateUrl: './parent-menu.component.html',
  styleUrls: ['./parent-menu.component.scss']
})
export class ParentMenuComponent implements OnInit, OnDestroy {
  routerList: Array<any>;
  @ViewChild('sidemenu') sideMenu;
  @HostBinding('class.ns-navigation-collapsed') navigationCollapsed = true;
  studentUserId;
  userFirstName;
  userLastName;
  isLogout = false;
  loginDetail: any = { info: { fileUrl: '', firstName: '', lastName: '' } };
  parentMenuLoader = false;
  isMobileVerison = false;
  coachingHours;
  menuScroll = false;
  pinMenuBar: boolean;
  currentRoute: any;
  saveModal = false;
  subscription: Subscription;
  subscriptionCurrentRoute: Subscription;
  checkDuplicateData: any;
  partnerDetail: any;

  constructor(
    @Inject(APP_CONFIG) private config: IAppConfig,
    private _commonAuthService: CommonAuthenticationService,
    private routeDataService: RouteDataService,
    private commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    public _router: Router,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _loginService: LoginService,
    private _menuService: MenuService,
    private renderer: Renderer2,
    private notificationService: NotificationService,
    private confirmModalService: ConfirmModalService
  ) {
    _router.events.subscribe(event => {

      if (event instanceof NavigationStart) {
        if (event.url !== '/parent/parentProfile') {
          this._commonDataSharedService.studentProfileNavigation.next(true);
        }
      }
    });
  }


  ngOnInit() {
    this.getCountValue();
    this.navigationCollapsed = true;
    this.subscription = this._commonDataSharedService.updateMessageCount.subscribe((value: any) => {
      this.getCountValue();
    })

    const partnerDetail = localStorage.getItem('partnerDetail');
    if (partnerDetail) {
      this.partnerDetail = JSON.parse(partnerDetail);
    }

    if (JSON.parse(localStorage.getItem('toggleMenu'))) {
      this.pinMenuBar = JSON.parse(localStorage.getItem('toggleMenu'));
      this.menuScroll = false;
    }
    this.parentMenuLoader = true;
    const routeParam = this._router.url.split('/').pop();
    let selectMenu;
    // this.getLoginDetail();
    this._commonDataSharedService.sidemenu.next(this.sideMenu);
    this._commonDataSharedService.collapseMenu.subscribe((data: any) => {
      this.navigationCollapsed = this.pinMenuBar ? false : true;
    });
    this.routeDataService.parentRouteData.subscribe((data: Array<any>) => {
      this.parentMenuLoader = false;
      this.routerList = data;
      this.commonService.setDataWithoutObservable(this.routerList, 'routerList');
      this.commonService.setBreadCrumb({ path: routeParam }, this.routerList, 'parent');
      selectMenu = this.commonService.checkParentExist(this.routerList, { path: routeParam })
      if (selectMenu.mainIndex > -1) {
        this.commonService.toggleSideMenu(this.routerList, this.routerList[selectMenu.mainIndex]);
      }
      this._menuService.selectMenu(this.routerList, { path: routeParam });
      // localStorage.setItem('currentPageData', JSON.stringify(route));
    });
    this.getLoginDetail();

    this.routeDataService.logout.subscribe((data: any) => {
      this.isLogout = true;
      // if (document.querySelector('.SnapABug_Button')['style']) {
      //   document.querySelector('.SnapABug_Button')['style']['display'] = 'none';
      // }
      this.commonService.hideHelpMenuAndPopup();
    });
    if (!this.isLogout) {
      this.onLiveChat();
      this.commonService.showHelpMenuAndPopup();
      // if (document.querySelector('.SnapABug_Button')) {
      //   document.querySelector('.SnapABug_Button')['style']['display'] = 'block';
      // }
    }

    // this.isMobileVerison = this.commonService.checkDeviceIsMobile();
    // if (this.isMobileVerison) {
    this._commonRequestResponseService.post('admin/getoperatingHours', {})
      .subscribe((data: any) => {
        this.coachingHours = data.message;
      }, err => {
        console.error('error', err)
      })
    this.subscriptionCurrentRoute = this._commonDataSharedService.saveModal.subscribe((data) => {
      this.currentRoute = data['currentRoute'];
      this.checkDuplicateData = data;
      this.saveModal = true;
    });
  }

  pinMenu(event) {
    event.stopPropagation()
    this.pinMenuBar = !this.pinMenuBar;
    localStorage.setItem('toggleMenu', this.pinMenuBar.toString())
    if (this.pinMenuBar) {
      this.navigationCollapsed = false;
      this.renderer.addClass(document.body, 'menu-open');
    } else {
      this.navigationCollapsed = true;
      this.renderer.removeClass(document.body, 'menu-open');
    }
  }

  onParentMenuClick(route, toggleFlag) {
    if (this._router.url.split('/').pop() === 'parentProfile') {
      this._commonDataSharedService.saveProfile.next();
    }
    if (toggleFlag) {
      this.commonService.toggleSideMenu(this.routerList, route);
    }
    if (!this.pinMenuBar) {
      this.renderer.removeClass(document.body, 'menu-open');
      this.navigationCollapsed = true;
      this.menuScroll = false;
    }
    if (this.saveModal && this.currentRoute === 'parentProfile' && route.path !== 'manageYourSubscription' && this.currentRoute !== route.path) {
      this.confirmModalService.open({
        ok: () => {
          if (!this.checkDuplicateData['duplicateEmail'] && !this.checkDuplicateData['duplicateMobile']) {
            this.routeDataService.setParentMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
            this._commonDataSharedService.studentProfileSave.next();
            this.saveModal = false;
            this._menuService.selectMenu(this.routerList, route);
          }
        },
        cancel: () => {
          this.routeDataService.setParentMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
          this.saveModal = false;
          this._menuService.selectMenu(this.routerList, route);
        },

        text: 'Would you like to save the changes you’ve made?',
        labels: ['Yes', 'No']
      });
    } else {
      if (route.innerItems.length <= 0) {
        this.commonService.setBreadCrumb(route, this.routerList, 'parent');
        this._menuService.setCurrentRouteData(route);
        this._menuService.selectMenu(this.routerList, route);
        // this.routeDataService.setParentMenuRoute.next(route.path);
        if (route.name.replace(/ /g, '').toLowerCase() === 'manageyoursubscription') {
          window.open(route.path, '_blank');
        } else {
          this.routeDataService.setParentMenuRoute.next('./../' + route.moduleName.toLowerCase().trim() + '/' + route.path);
        }
      }
    }


  }

  onLiveChat() {
    const snapEngage = this.partnerDetail ? this.partnerDetail.snapEngage : '';
    const __this = this;
    (function () {
      const se = document.createElement('script'); se.type = 'text/javascript'; se.async = true;
      se.src = snapEngage;
      let done = false;
      se.onload = function () {
        if (!done && __this.loginDetail) {
          done = true;
          SnapEngage.setUserEmail(__this.loginDetail.email);
          SnapEngage.setUserName(__this.studentUserId);
        }
      }
      const s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(se, s);
    })();

    if ($('#snapengage-mobile')) {
      setTimeout(function () {
        $('#snapengage-mobile').css({ 'z-index': '99999999', 'top': '31px', 'bottom': '31px', 'right': '31px', 'left': '31px' });

        const iframe: any = document.getElementById('snapengage-mobile-iframe');

        if (iframe) {
          const innerDoc = iframe.contentDocument || iframe.contentWindow.document;
          innerDoc.getElementById('SnapABug_email').value = __this.loginDetail.email;
        }
      }, 1000);
    }
  }

  myAccount() {
    this._router.navigate(['/parent/myAccount']);
  }
  getCountValue() {
    this._commonRequestResponseService.post('shared/get/counts', { userRoleData: this._commonAuthService.getRoleName() })
      .subscribe(
        (countData: any) => {
          this._commonDataSharedService.countUpdate.next(countData);
        },
        () => {
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  logout() {
    this.renderer.removeClass(document.body, 'menu-open');
    this._loginService.logout().subscribe(() => {
      this.isLogout = true;
    });

  }

  getLoginDetail() {
    this.loginDetail = this._commonAuthService.getLoginData();
    if (this.loginDetail) {
      this.studentUserId = this.loginDetail.userId;
      this.userFirstName = this.loginDetail.firstName;
      this.userLastName = this.loginDetail.lastName;
    }
    if (this.loginDetail.isLogin === 'true') {
      this.isLogout = false;
    }
  }

  toggleNavigationCollapse() {
    if (this.pinMenuBar && this.navigationCollapsed) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else if (!this.pinMenuBar && this.navigationCollapsed) {
      this.renderer.addClass(document.body, 'menu-open');
    }
    else {
      this.renderer.removeClass(document.body, 'menu-open');
    }
    this.navigationCollapsed = !this.navigationCollapsed;
    this.menuScroll = !this.menuScroll;
    localStorage.setItem('toggleMenu', this.navigationCollapsed.toString())
  }

  toggleNavigationCollapseMobile(shouldCollapseMenu: boolean) {
    if (typeof shouldCollapseMenu === 'undefined') {
      shouldCollapseMenu = true;
    }
    if ((window.innerWidth) < 980 && shouldCollapseMenu) {
      this.navigationCollapsed = !this.navigationCollapsed;
    }
  }

  routeHasChildren(route) {
    return route.innerItems.filter((item) => item.access === 'true').length > 0;
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.subscriptionCurrentRoute.unsubscribe();
  }

}
